// Retired shopping filter links must still lead to the property directory.
const directoryUrl = new URL(window.location.href);
let refreshDirectory = false;
for (const parameter of ['filter.v.availability', 'filter.v.price.gte', 'filter.v.price.lte']) {
  if (directoryUrl.searchParams.has(parameter)) {
    directoryUrl.searchParams.delete(parameter);
    refreshDirectory = true;
  }
}
const directorySort = directoryUrl.searchParams.get('sort_by');
if (directorySort?.startsWith('price-')) {
  directoryUrl.searchParams.delete('sort_by');
  refreshDirectory = true;
}
if (refreshDirectory) {
  directoryUrl.searchParams.delete('page');
  window.location.replace(directoryUrl.toString());
}
